// extracted by mini-css-extract-plugin
export var home__productListDivider = "homeProductList-module--home__productListDivider--wNwrz";
export var home__productListImage = "homeProductList-module--home__productListImage--2EXxc";
export var home__productListItem = "homeProductList-module--home__productListItem--HQLzi";
export var home__productListItems = "homeProductList-module--home__productListItems--EP7GT";
export var home__productPrice = "homeProductList-module--home__productPrice--viwK8";